import { environment } from './../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HandleError, HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable, of } from 'rxjs';
import { retry } from 'rxjs/operators';
import { RecuperarContrasenaEntry } from 'src/app/shared/entrys/recuperar-contrasena.entry';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';


@Injectable()
export class RecuperarContrasenaService implements RequestCRUD<RecuperarContrasenaEntry, ResponseServiceModel> {
	private API_URL;
	constructor(private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
	}

	get(entry: RecuperarContrasenaEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	update(entry: RecuperarContrasenaEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/recuperarclave`, entry).pipe(
			retry(2)
		);
	}
	getPista(entry: RecuperarContrasenaEntry): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/RecuperarClave/PorUsuario`, { usuario: entry.usuario }).pipe(
			retry(2)
		);
	}
	create(entry: RecuperarContrasenaEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	delete(entry: RecuperarContrasenaEntry): Observable<ResponseServiceModel> {
		throw new Error('Method not implemented.');
	}
	reenviar(entry: any): Observable<ResponseServiceModel> {
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/usuario/ReenviarCorreo`, entry).pipe(
			retry(2));
	}
}
